/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_UnknownInputs */



/**
* | output |
* | --- |
* | "Outcome unknown" |
*
* @param {Chat_Tool_Result_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_unknown = /** @type {((inputs?: Chat_Tool_Result_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnis unbekannt")
	return /** @type {LocalizedString} */ ("Outcome unknown")
});